

define(['jquery', 'squid/index', 'text!./template.html', 'xo-beaver/dist/logger'], function ($, squid, template) {

    squid.module('xo-spinner.directive', ['squid', 'beaver']).directive('xoSpinner', function () {

        return {
            scope: {},
            template: template,
            controller: function controller($scope, $element, $rootScope, $Api, $locale, $logger, $loader, $timeout) {

                var $body = angular.element(document.getElementsByTagName('body'));
                var $priorActiveElement = $();
                var $capturedElement = $();
                var $header = $('header');
                var $slidingArea = $('#main');
                var $footer = $('footer');

                /**
                 * This hides page content from any screen readers.
                 * When the spinner's active, the only thing that should be read out is the "Loading..." text.
                 *
                 * The only crappy thing here is the spinner's nested deep in the content, so please excuse this jQuery crap.
                 * At the very least, let's cache these selectors :|
                 */
                function hidePageContentFromScreenReader(toggle) {
                    $header.attr('aria-disabled', toggle);
                    $slidingArea.attr('aria-disabled', toggle);
                    $footer.attr('aria-disabled', toggle);
                }

                function preventDefault(event) {
                    var _event$target = event.target;
                    _event$target = _event$target === undefined ? {} : _event$target;
                    var targetId = _event$target.id;

                    // Only call preventDefault if the target is not a captcha input.
                    // If the target is a captcha input we don't want to prevent the
                    // user from entering the captcha code.

                    if (targetId !== 'captchaCode') {
                        event.preventDefault();
                    }
                }

                function captureFocus(event) {
                    if (!$element.has(event.target).length) {
                        $capturedElement = $(event.target);
                    }
                }

                function setLoadingMessage(message) {
                    if (angular.isObject(message)) {
                        $scope.message = message.heading;
                        $('#spinnerMessage').css('font-size', '17.5px');
                        $('#spinnerMessage').html(message.heading);
                        $('#spinnerSubHeading').html(message.subHeading);
                    } else {
                        $scope.message = message;
                        $('#spinnerMessage').html(message);
                    }
                }

                function showSpinner() {
                    $scope.loading = true;
                    $logger.info('show_loading_spinner');
                    $body.addClass('loading');

                    // remember what was previously focused
                    $priorActiveElement = $(':focus');

                    $(':input, a').blur();

                    hidePageContentFromScreenReader(true);

                    if ($loader.firstLoad()) {
                        setLoadingMessage($locale.content.get('base.processing'));
                    }

                    // focus on the message so that screen readers will let the user know the page is loading
                    $(document).on('keydown', preventDefault);
                    $(document).on('focusin', captureFocus);
                    $timeout(function () {
                        $('#spinner-message').focus();
                    });
                }

                function hideSpinner() {
                    $scope.loading = false;
                    $logger.info('hide_loading_spinner');
                    $('#preloaderSpinner').hide();
                    $body.removeClass('loading');
                    $(document).off('keydown', preventDefault);
                    $(document).off('focusin', captureFocus);

                    hidePageContentFromScreenReader(false);

                    // Focus captured element if focus was given to an element while spinner was active.
                    if ($capturedElement.length && $(document.body).has($capturedElement).length) {
                        $capturedElement.focus();
                        // Focus element that had focus before if it is still within the document
                    } else if ($priorActiveElement.length && $(document.body).has($priorActiveElement).length) {
                        $priorActiveElement.focus();
                    } else {
                        // If focus is not managed, default to focusing sliding area. Fixes FF and IE bug where tab focus starts from
                        // the element last clicked, rather than top of page.
                        $slidingArea.focus();
                    }
                    $priorActiveElement = $();
                    $capturedElement = $();
                }

                var cancelStartLoad = $rootScope.$on('startLoad', showSpinner);
                var cancelAllLoaded = $rootScope.$on('allLoaded', hideSpinner);

                var cancelSetLoadingMessage = $rootScope.$on('loadingMessage', function (event, text) {
                    setLoadingMessage(text);
                });

                $scope.$on('$destroy', function () {
                    hideSpinner();
                    cancelStartLoad();
                    cancelAllLoaded();
                    cancelSetLoadingMessage();
                });

                if ($loader.isLoading()) {
                    showSpinner();
                }
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-ui-components/src/spinner/directive.js
// module id = ./components/xo-ui-components/src/spinner/directive.js
// module chunks = 1